import BgShape from "../images/hero/hero-bg1.png";
import BgShape1 from "../images/hero/hero-bg2.jpg";
import { useEffect, useState } from "react";
import whatsapp from "../images/logo/whatsapp.png";
import facebook from "../images/logo/fb.png";
import './shining.css'; // Ensure this is your CSS file path

function Hero() {
  const [goUp, setGoUp] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [imageSrc, setImageSrc] = useState(BgShape);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/12424391303', '_blank'); 
  };

  const openFacebook = () => {
    window.open('https://www.facebook.com/BullseyeCarRentals/', '_blank');
  };

  useEffect(() => {
    const onPageScroll = () => {
      if (window.pageYOffset > 600) {
        setGoUp(true);
      } else {
        setGoUp(false);
      }
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('scroll', onPageScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', onPageScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setImageSrc(BgShape1);
      } else {
        setImageSrc(BgShape);
      }
    };

    handleResize(); // Check on mount
    window.addEventListener('resize', handleResize); // Add listener

    return () => {
      window.removeEventListener('resize', handleResize); // Clean up listener on unmount
    };
  }, []);

  // Dynamic styles based on screen width
  const containerStyle = {
    position: 'relative', 
    height: '730px', 
    marginTop: '-45px', backgroundColor:'#ffd700', borderRadius:'360px',  //backgroundColor:'#ffd700'
  };

  const bgImageStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: windowWidth < 550 ? '85%' : '100%', // Set height to 85% for screen width < 550px
    zIndex: '16',
  };

  const textStyle = {
    animation: 'fadeIn 3s ease-in-out, glow 1.5s infinite alternate',
  };

  return (
    <section id="home" className="banner-section" style={containerStyle}>
      <div className="container">
        <img src={imageSrc} alt="Background Shape" style={bgImageStyle} />
        <div style={{ position: 'relative', zIndex: 2, height: '350px', marginTop: '14.5rem', zIndex: '16' }}>
          <h1 
            className="main-heading"
            style={{
              marginTop: windowWidth < 550 ? '-25px' : '39px',  // Set marginTop to 12px for screen width < 550px
              animation: 'glowText 1.5s infinite alternate, bounce 2s ease-in-out',
              textAlign: 'center', 
              fontSize: windowWidth < 550 ? '2.7rem' : '3.9rem', // Set font size to 4rem for screen width < 550px
              fontFamily: "'Anton'", 
              fontWeight: 'bold',
              textTransform: 'uppercase', 
              zIndex: '16', lineHeight:'1.4'
            }}
          >
            Top-Rated Car Rental Services <br></br>in Freeport, <br></br>
            Grand Bahama
          </h1>
        </div>
      </div>

      {/* WhatsApp button */}
      <div onClick={openWhatsApp} className="whatsapp-btn" style={{ position: 'fixed', bottom: '324px', left: '1rem', zIndex: '24' }}>
        <img src={whatsapp} alt="WhatsApp" style={{ height: 52, width: 52, borderRadius: '7px'  }} />
      </div>

      {/* Facebook button */}
      <div onClick={openFacebook} className="whatsapp-btn" style={{ position: 'fixed', bottom: '240px', left: '1rem', zIndex: '24' }}>
        <img src={facebook} alt="Facebook" style={{ height: 52, width: 52, borderRadius: '7px' }} />
      </div>

      {/* Scroll to top button */}
      <div
        style={{
          background: 'linear-gradient(325deg, #f7e9a0, #ffcc00, #d4af37, #b8860b)',
          backgroundSize: '200% 200%',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
        }}
        onClick={scrollToTop}
        className={`scroll-up ${goUp ? 'show-scroll' : ''}`}
      >
        <p style={{ fontSize: 22 }}>&#9650;</p>
      </div>
    </section>
  );
}

export default Hero;